import { MediaUpload, MediaUploadCheck } from "@wordpress/block-editor";
import { Button } from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import React from "react";
//@ts-ignore
import { Image } from "@chakra-ui/react";
import placeholderImage from "../../../images/placeholder.png";

type Props = {
	onChange?: (value: unknown) => void;
	type?: string;
	value?: {
		url?: string;
		[key: string]: string | number | undefined;
	};
	label?: string;
};

const Media: React.FC<Props> = (props) => {
	const { onChange, type = "image", value = {}, label } = props;

	const buttonString = value?.url
		? __("Replace", "magazine-blocks") +
		  " " +
		  ("image" === type ? "Image" : "Video")
		: __("Add", "magazine-blocks") +
		  " " +
		  ("image" === type ? "Image" : "Video");

	const onSelect = (media: {
		url?: string;
		id?: number;
		height?: number;
		width?: number;
		alt?: string;
	}) => {
		if (!media?.url) {
			return;
		}
		const { url, id, height, width, alt } = media;
		onChange?.({ url, id, height, width, alt });
	};

	const renderPreview = () => {
		if (!value?.url) {
			return (
				<Image
					src={value?.url || placeholderImage}
					alt={__("mzb preview image", "magazine-blocks")}
				/>
			);
		}

		if (type === "video") {
			return (
				<video
					src={value.url}
					controls
					style={{
						width: "100%",
						height: "100%",
						objectFit: "cover",
					}}
				>
					Your browser does not support the video tag.
				</video>
			);
		}

		return (
			<img
				src={value.url}
				alt={__("mzb preview image", "magazine-blocks")}
			/>
		);
	};

	return (
		<div className="mzb-control mzb-media">
			<div
				className="mzb-control-head mzb-media-head"
				style={{ marginBottom: "12px" }}
			>
				<label htmlFor="mzb-media-head">{label}</label>
			</div>
			<div className="mzb-control-body mzb-media-body">
				<MediaUploadCheck>
					<MediaUpload
						onSelect={onSelect}
						allowedTypes={[type]}
						title={
							"Upload " + (type === "image" ? "Image" : "Video")
						}
						render={({ open }) => (
							<>
								<div
									className="mzb-media-placeholder mzb-media-preview"
									onClick={open}
									onKeyDown={(e) => "Enter" === e.key && open}
									role="button"
									tabIndex={0}
									title={buttonString}
								>
									{renderPreview()}
								</div>
								<Button
									className="mzb-media-button"
									onClick={open}
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 24 24"
										width="24px"
										height="24px"
									>
										<path
											fillRule="evenodd"
											// eslint-disable-next-line max-len
											d="M6 4a2 2 0 0 0-2 2v7.586l3.293-3.293.014-.014c.614-.59 1.37-.949 2.193-.949s1.58.358 2.193.95l.014.013L14 12.586l.293-.293.014-.014c.614-.59 1.37-.949 2.193-.949s1.58.358 2.193.95l.014.013L20 13.586V6a2 2 0 0 0-2-2H6Zm16 11.999V6a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-2.001Zm-2 .415-2.7-2.7c-.311-.297-.588-.384-.8-.384-.212 0-.489.087-.8.385l-.286.285 1.293 1.293a1 1 0 0 1-1.414 1.414L10.3 11.715c-.311-.298-.588-.385-.8-.385-.212 0-.489.087-.8.385l-4.7 4.7V18a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1.586ZM14 8a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1Z"
											clipRule="evenodd"
										></path>
									</svg>
									<span className="mzb-media-button-text">
										{buttonString}
									</span>
								</Button>
								{value && (
									<Button
										className="mzb-media-delete"
										onClick={() => onChange?.("")}
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 24 24"
											height={20}
											fill="#1a202c"
										>
											<path d="M5 20c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V8h2V6h-4V4c0-1.1-.9-2-2-2H9c-1.2 0-2 .9-2 2v2H3v2h2v12zM9 4h6v2H9V4zM7.9 8h9v12H7V8h.9z" />
											<path d="M9.4 10.7h1.7v7H9.4v-7zm3.4 0h1.7v7h-1.7v-7z" />
										</svg>
									</Button>
								)}
							</>
						)}
					/>
				</MediaUploadCheck>
			</div>
		</div>
	);
};

export default Media;
